import Vue from "vue";

export const question = (x, payload) =>
  Vue.$axios.post(`contact/question`, payload).catch(() => Promise.reject());
